export async function fetchProducts() {
  const url = 'http://3.36.132.32:8080/api/products';
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

export async function fetchProduct(productId) {
  const url = `http://3.36.132.32:8080/api/products/${productId}`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

export async function postProduct(product) {
  const url = 'http://3.36.132.32:8080/api/products';
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(product),
  });

  return response;
}

